import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePostHog, POSTHOG_EVENTS } from '../../../components/analytics/PostHogProvider';


const ProvidersUpload = () => {
  const navigate = useNavigate();
  const [scheduleForLater, setScheduleForLater] = useState(false);
  const { captureEvent } = usePostHog();

  // Track providers upload page view
  useEffect(() => {
    captureEvent(POSTHOG_EVENTS.PROVIDERS_UPLOAD_STARTED);
  }, [captureEvent]);

  const providers = [
    { email: 'john.smith@clinic.com', specialty: 'Cardiology' },
    { email: 'sarah.johnson@clinic.com', specialty: 'Pediatrics' },
    { email: 'michael.brown@clinic.com', specialty: 'Orthopedics' },
    { email: 'emily.davis@clinic.com', specialty: 'Neurology' }
  ];

  const handleStartSync = () => {
    console.log('Start Sync clicked');
  };

  const handleDownloadTemplate = () => {
    console.log('Download Template clicked');
  };

  const handleUploadCSV = () => {
    console.log('Upload CSV clicked');
  };

  const handleAddProvider = () => {
    console.log('Add Provider clicked');
  };

  const handleSendInvites = () => {
    console.log('Send All Invites clicked');
  };

  const handlePrevious = () => {
    navigate('/onboarding/ehr-connect');
  };

  const handleCompleteUpload = () => {
    console.log('Complete Upload clicked');
    navigate('/onboarding/payment');
  };

  return (
    <div className="min-vh-100 bg-light p-3 p-md-6" style={{ minHeight: '100vh', background: '#f1f5f9', padding: '2rem 6rem' }}>
      <div className="mx-auto" style={{ maxWidth: 1200, margin: '0 auto' }}>
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-4" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
          <h1 className="h1 mb-0" style={{ fontSize: '1.75rem', fontWeight: 700, color: '#1e293b', margin: 0 }}>Providers Upload</h1>
          <div className="d-flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: 0 }}>
            <span className="fs-5" style={{ fontSize: '1.25rem' }}>⭐</span>
            <span className="fw-bold" style={{ fontSize: '1rem', fontWeight: 700, color: '#f59e0b' }}>150 XP</span>
            <span className="text-muted small" style={{ fontSize: '0.875rem', color: '#94a3b8' }}>upon completion</span>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="mb-5" style={{ marginBottom: '2rem' }}>
          <div className="progress mb-2" style={{ width: '100%', height: 6, background: '#e2e8f0', borderRadius: 3, marginBottom: '0.5rem' }}>
            <div 
              className="progress-bar bg-primary" 
              style={{ 
                height: '100%', 
                background: 'linear-gradient(90deg, #3b82f6 0%, #8b5cf6 100%)', 
                transition: 'width 0.3s ease', 
                borderRadius: 3, 
                width: '62.5%' 
              }}
            />
          </div>
          <div className="text-end text-muted small" style={{ textAlign: 'right', fontSize: '0.875rem', color: '#64748b' }}>Step 5 of 8</div>
        </div>

        {/* Upload Methods Card */}
        <div className="bg-white rounded-4 shadow-sm p-4 mb-5" style={{ 
          background: 'white', 
          borderRadius: 16, 
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', 
          padding: '2rem', 
          marginBottom: '2rem' 
        }}>
          <div className="mb-4" style={{ marginBottom: '2rem' }}>
            <h2 className="h3 mb-2" style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1e293b', margin: '0 0 0.5rem 0' }}>Choose Upload Method</h2>
            <p className="text-muted mb-0" style={{ fontSize: '1rem', color: '#64748b', margin: 0 }}>
              Add your healthcare providers to enable Ankr&apos;s AI assistant features
            </p>
          </div>

          <div className="row g-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
            {/* Sync from EHR */}
            <div className="col" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem', border: '1px solid #e2e8f0', borderRadius: 12, transition: 'all 0.2s' }} onMouseEnter={(e) => {
              e.target.style.borderColor = '#cbd5e1';
              e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.08)';
              e.target.style.transform = 'translateY(-2px)';
            }} onMouseLeave={(e) => {
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.boxShadow = 'none';
              e.target.style.transform = 'translateY(0)';
            }}>
              <div className="d-flex align-items-center justify-content-center rounded-3 mb-3" style={{ 
                width: 64, 
                height: 64, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                borderRadius: 12, 
                marginBottom: '1rem', 
                backgroundColor: '#dbeafe', 
                color: '#3b82f6', 
                fontSize: 24 
              }}>
                🔄
              </div>
              <h3 className="h5 mb-2" style={{ fontSize: '1.125rem', fontWeight: 600, color: '#1e293b', margin: '0 0 0.5rem 0' }}>Sync from EHR</h3>
              <p className="text-muted mb-4" style={{ fontSize: '0.875rem', color: '#64748b', margin: '0 0 1.5rem 0', lineHeight: 1.5 }}>
                Automatically import providers from your connected EHR system
              </p>
              <button className="btn btn-primary w-100" style={{ width: '100%', padding: '0.75rem 1rem', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', background: '#3b82f6', color: 'white', border: 'none', transition: 'all 0.2s' }} onMouseEnter={(e) => {
                e.target.style.background = '#2563eb';
                e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
              }} onMouseLeave={(e) => {
                e.target.style.background = '#3b82f6';
                e.target.style.boxShadow = 'none';
              }} onClick={handleStartSync}>
                Start Sync
              </button>
            </div>

            {/* Upload CSV */}
            <div className="col" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem', border: '1px solid #e2e8f0', borderRadius: 12, transition: 'all 0.2s' }} onMouseEnter={(e) => {
              e.target.style.borderColor = '#cbd5e1';
              e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.08)';
              e.target.style.transform = 'translateY(-2px)';
            }} onMouseLeave={(e) => {
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.boxShadow = 'none';
              e.target.style.transform = 'translateY(0)';
            }}>
              <div className="d-flex align-items-center justify-content-center rounded-3 mb-3" style={{ 
                width: 64, 
                height: 64, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                borderRadius: 12, 
                marginBottom: '1rem', 
                backgroundColor: '#d1fae5', 
                color: '#10b981', 
                fontSize: 24 
              }}>
                📊
              </div>
              <h3 className="h5 mb-2" style={{ fontSize: '1.125rem', fontWeight: 600, color: '#1e293b', margin: '0 0 0.5rem 0' }}>Upload CSV</h3>
              <p className="text-muted mb-4" style={{ fontSize: '0.875rem', color: '#64748b', margin: '0 0 1.5rem 0', lineHeight: 1.5 }}>
                Download template and upload your provider list
              </p>
              <button className="btn btn-outline-secondary w-100 mb-3" style={{ width: '100%', padding: '0.75rem 1rem', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', background: 'white', color: '#64748b', border: '1px solid #e2e8f0', transition: 'all 0.2s', marginTop: '0.75rem' }} onMouseEnter={(e) => {
                e.target.style.background = '#f8fafc';
                e.target.style.borderColor = '#cbd5e1';
              }} onMouseLeave={(e) => {
                e.target.style.background = 'white';
                e.target.style.borderColor = '#e2e8f0';
              }} onClick={handleDownloadTemplate}>
                <span style={{ fontSize: '1rem' }}>⬇</span>
                Download Template
              </button>
              <button className="btn btn-success w-100" style={{ width: '100%', padding: '0.75rem 1rem', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', background: '#10b981', color: 'white', border: 'none', transition: 'all 0.2s' }} onMouseEnter={(e) => {
                e.target.style.background = '#059669';
                e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
              }} onMouseLeave={(e) => {
                e.target.style.background = '#10b981';
                e.target.style.boxShadow = 'none';
              }} onClick={handleUploadCSV}>
                <span style={{ fontSize: '1rem' }}>⬆</span>
                Upload CSV
              </button>
            </div>

            {/* Manual Add */}
            <div className="col" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem', border: '1px solid #e2e8f0', borderRadius: 12, transition: 'all 0.2s' }} onMouseEnter={(e) => {
              e.target.style.borderColor = '#cbd5e1';
              e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.08)';
              e.target.style.transform = 'translateY(-2px)';
            }} onMouseLeave={(e) => {
              e.target.style.borderColor = '#e2e8f0';
              e.target.style.boxShadow = 'none';
              e.target.style.transform = 'translateY(0)';
            }}>
              <div className="d-flex align-items-center justify-content-center rounded-3 mb-3" style={{ 
                width: 64, 
                height: 64, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                borderRadius: 12, 
                marginBottom: '1rem', 
                backgroundColor: '#e9d5ff', 
                color: '#a855f7', 
                fontSize: 24 
              }}>
                👥
              </div>
              <h3 className="h5 mb-2" style={{ fontSize: '1.125rem', fontWeight: 600, color: '#1e293b', margin: '0 0 0.5rem 0' }}>Manual Add</h3>
              <p className="text-muted mb-4" style={{ fontSize: '0.875rem', color: '#64748b', margin: '0 0 1.5rem 0', lineHeight: 1.5 }}>
                Add providers one by one using the form
              </p>
              <button className="btn w-100" style={{ width: '100%', padding: '0.75rem 1rem', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', background: '#a855f7', color: 'white', border: 'none', transition: 'all 0.2s' }} onMouseEnter={(e) => {
                e.target.style.background = '#9333ea';
                e.target.style.boxShadow = '0 4px 12px rgba(168, 85, 247, 0.3)';
              }} onMouseLeave={(e) => {
                e.target.style.background = '#a855f7';
                e.target.style.boxShadow = 'none';
              }} onClick={handleAddProvider}>
                Add Provider
              </button>
            </div>
          </div>
        </div>

        {/* Bulk Invites Card */}
        <div className="bg-white rounded-4 shadow-sm p-4 mb-5" style={{ 
          background: 'white', 
          borderRadius: 16, 
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)', 
          padding: '2rem', 
          marginBottom: '2rem' 
        }}>
          <div className="mb-4" style={{ marginBottom: '2rem' }}>
            <h2 className="h3 mb-2" style={{ fontSize: '1.5rem', fontWeight: 700, color: '#1e293b', margin: '0 0 0.5rem 0' }}>Send Bulk Invites</h2>
            <p className="text-muted mb-0" style={{ fontSize: '1rem', color: '#64748b', margin: 0 }}>
              Invite all providers to create their Ankr accounts
            </p>
          </div>

          <div className="bg-light rounded-3 p-4" style={{ background: '#f8fafc', borderRadius: 12, padding: '1.5rem' }}>
            <div className="d-flex justify-content-between align-items-start mb-4" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
              <div>
                <h3 className="h5 mb-1" style={{ fontSize: '1.125rem', fontWeight: 600, color: '#1e293b', margin: '0 0 0.25rem 0' }}>Ready to Invite</h3>
                <p className="text-muted mb-0" style={{ fontSize: '0.875rem', color: '#64748b', margin: 0 }}>
                  {providers.length} providers will receive account setup emails
                </p>
              </div>
              <div className="d-flex flex-column align-items-center text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1rem', borderRadius: 8, border: '1px solid #e2e8f0' }}>
                <span className="fw-bold" style={{ fontSize: '2rem', fontWeight: 700, color: '#1e293b', lineHeight: 1 }}>{providers.length}</span>
                <span className="text-uppercase small text-muted" style={{ fontSize: '0.75rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px' }}>providers</span>
              </div>
            </div>

            <div className="mb-4" style={{ marginBottom: '1.5rem' }}>
              {providers.map((provider, index) => (
                <div key={index} className="d-flex justify-content-between align-items-center py-2 border-bottom" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem 0', borderBottom: '1px solid #e2e8f0' }}>
                  <span className="fw-medium" style={{ fontSize: '0.9375rem', color: '#1e293b', fontWeight: 500 }}>{provider.email}</span>
                  <span className="text-muted" style={{ fontSize: '0.875rem', color: '#64748b' }}>{provider.specialty}</span>
                </div>
              ))}
            </div>

            <div className="d-flex justify-content-between align-items-center pt-3 border-top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1.5rem 0 0 0', borderTop: '1px solid #e2e8f0' }}>
              <label className="d-flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', color: '#64748b' }}>
                <input
                  type="checkbox"
                  checked={scheduleForLater}
                  onChange={(e) => setScheduleForLater(e.target.checked)}
                  className="form-check-input me-2" 
                  style={{ width: 18, height: 18, cursor: 'pointer', accentColor: '#3b82f6' }}
                />
                <span>Schedule invites for later</span>
              </label>
              <button className="btn btn-primary d-flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.75rem 1.5rem', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', background: '#3b82f6', color: 'white', border: 'none', transition: 'all 0.2s' }} onMouseEnter={(e) => {
                e.target.style.background = '#2563eb';
                e.target.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)';
              }} onMouseLeave={(e) => {
                e.target.style.background = '#3b82f6';
                e.target.style.boxShadow = 'none';
              }} onClick={handleSendInvites}>
                <span style={{ fontSize: '1rem' }}>✉️</span>
                Send All Invites
              </button>
            </div>
          </div>
        </div>

        {/* Speed Loader Badge */}
        <div className="d-flex justify-content-between align-items-center bg-warning bg-opacity-10 rounded-4 p-4 mb-5" style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          background: 'rgba(245, 158, 11, 0.1)', 
          border: '1px solid #f59e0b', 
          borderRadius: 12, 
          padding: '1.5rem', 
          marginBottom: '2rem' 
        }}>
          <div className="d-flex align-items-center gap-3 flex-grow-1" style={{ display: 'flex', alignItems: 'center', gap: '1rem', flex: 1 }}>
            <span className="fs-2" style={{ fontSize: '2rem', flexShrink: 0 }}>⚡</span>
            <div>
              <strong className="d-block mb-1" style={{ display: 'block', fontSize: '1rem', color: '#92400e', marginBottom: '0.25rem' }}>Speed Loader Badge Available!</strong>
              <p className="mb-0" style={{ fontSize: '0.875rem', color: '#78350f', margin: 0, lineHeight: 1.5 }}>Complete provider upload in this session to earn the exclusive &quot;Speed Loader&quot; badge</p>
            </div>
          </div>
          <div className="d-flex flex-column align-items-end text-end" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', textAlign: 'right' }}>
            <span className="fw-bold" style={{ fontSize: '1.125rem', fontWeight: 700, color: '#f59e0b' }}>+50 Bonus XP</span>
            <span className="text-uppercase small" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Limited time</span>
          </div>
        </div>

        {/* Footer Navigation */}
        <div className="d-flex justify-content-between gap-3" style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
          <button className="btn btn-outline-secondary" onClick={handlePrevious} style={{ padding: '0.75rem 1.5rem', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', background: 'white', color: '#64748b', border: '1px solid #e2e8f0', transition: 'all 0.2s' }} onMouseEnter={(e) => {
            e.target.style.background = '#f8fafc';
            e.target.style.borderColor = '#cbd5e1';
          }} onMouseLeave={(e) => {
            e.target.style.background = 'white';
            e.target.style.borderColor = '#e2e8f0';
          }}>
            ← Previous
          </button>
          <button className="btn btn-success" onClick={handleCompleteUpload} style={{ padding: '0.75rem 1.5rem', borderRadius: 8, fontSize: '0.875rem', fontWeight: 500, cursor: 'pointer', background: '#10b981', color: 'white', border: 'none', transition: 'all 0.2s' }} onMouseEnter={(e) => {
            e.target.style.background = '#059669';
            e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
          }} onMouseLeave={(e) => {
            e.target.style.background = '#10b981';
            e.target.style.boxShadow = 'none';
          }}>
            Complete Upload ✓
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProvidersUpload;
